<template>
  <v-row>
        <v-col cols="12" class="text-h5 font-weight-bold">
          Informações da Turma Selecionada
        </v-col>

        <v-col cols="4">
          <v-text-field
            v-model="turma.escola"
            label="Escola"
            outlined
            dense
            readonly
          />
        </v-col>
        <v-col cols="4">
          <v-text-field
            v-model="turma.municipio"
            label="Município"
            outlined
            dense
            readonly
          />
        </v-col>
        <v-col cols="4">
          <v-text-field
            v-model="turma.gre"
            label="GRE"
            outlined
            dense
            readonly
          />
        </v-col>
        <v-col cols="4">
          <v-text-field
            v-model="turma.nomeTurma"
            label="Nome da Turma"
            outlined
            dense
            readonly
          />
        </v-col>
        <v-col cols="4">
          <v-text-field
            v-model="turma.anoSerie"
            label="Ano/Série"
            outlined
            dense
            readonly
          />
        </v-col>
        <v-col cols="4">
          <v-text-field
            v-model="turma.estudantesMatriculados"
            label="Quantidade de Estudantes Matriculados"
            outlined
            dense
            readonly
          />
        </v-col>
      </v-row>
</template>
<script>
export default {
  name: 'DadosDaTurmaComponent',
  props: {
    turma: {
      type: Object,
      required: true
    }
  }
};

</script>